module.exports = __webpack_public_path__ + "img/banner_en.ede3c83b.png";